var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataSource)?_c('AggregateRowsDataSourceForm',{ref:"dataSourceForm",attrs:{"dashboard":_vm.dashboard,"widget":_vm.widget,"data-source":_vm.dataSource,"default-values":_vm.dataSource,"store-prefix":_vm.storePrefix},on:{"values-changed":_vm.onDataSourceValuesChanged}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }